// MySlider.tsx
import { A11y, Scrollbar } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import { forwardRef, MutableRefObject } from "react";
import type { Swiper as SwiperType } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useSlides } from "./helpers/useSlideHelper";
import { MobileConfiguratorOptionHeader } from "./MobileConfiguratorOptionHeader";
import { MobileConfiguratorModalTemplate } from "./MobileConfiguratorModalTemplate";
type MobileConfiguratorProgressBarProps = {
  activeIndex: number;
  setActiveIndex: (index: number) => void;
};
export const MobileConfiguratorMainContent = forwardRef<
  any | null,
  MobileConfiguratorProgressBarProps
>(({ activeIndex, setActiveIndex }, ref) => {
  const swiperRef = ref as MutableRefObject<SwiperType>;
  const { slides } = useSlides();

  return (
    <MobileConfiguratorModalTemplate>
      <div className="gg-max-h-[630px]">
        {/* Sticky header */}
        <MobileConfiguratorOptionHeader activeIndex={activeIndex} />
        <div className="gg-min-h-[650px] gg-space-y-4 gg-bg-[#f5f4f4] gg-py-2.5">
          <Swiper
            modules={[Scrollbar, A11y]}
            spaceBetween={20}
            slidesPerView={1.15}
            onSwiper={(swiper: SwiperType) => {
              swiperRef.current = swiper;
            }}
            onSlideChange={(swiper: SwiperType) =>
              setActiveIndex(swiper.activeIndex)
            }
          >
            {slides.map((slide, idx) => (
              <SwiperSlide key={slide.name} style={{ height: "500px" }}>
                <slide.Step />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </MobileConfiguratorModalTemplate>
  );
});
